import { login, logout, getInfo, loginBackground, loginFactoryBackground } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from "js-cookie";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 切换用户--服务商
    switchLogin({ commit }, siteId) {
      return new Promise((resolve, reject) => {
        loginBackground(siteId).then(res => {
          // Cookies.remove("rememberMe");
          Cookies.remove("password");
          Cookies.remove("username");
          Cookies.remove("userType");
          Cookies.remove("userId");
          // commit('SET_TOKEN', '')
          // removeToken();
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 切换用户--品牌商
    switchFactoryLogin({ commit }, factoryId) {
      return new Promise((resolve, reject) => {
        loginFactoryBackground(factoryId).then(res => {
          Cookies.remove("password");
          Cookies.remove("username");
          Cookies.remove("userType");
          Cookies.remove("userId");
          // commit('SET_TOKEN', '')
          // removeToken();
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          Cookies.set("userType", res.user.userType, { expires: 30 }); //用户类型：0.超级管理员1.平台管理员 2厂家人员 3.服务商 4.平台员工 5.服务商人员 6.厂家员工
          Cookies.set("userId", res.user.userId, { expires: 30 }); //用户Id
          Cookies.set("factoryId", res.user.factoryId, { expires: 30 }); //factoryId
          Cookies.set("createBy", res.user.createBy, { expires: 30 }); //createBy
          res.user.siteId? Cookies.set("siteId", res.user.siteId):''

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
          Cookies.remove("userType");
          Cookies.remove("userId");
          Cookies.remove("factoryId");
          Cookies.remove("createBy");
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        Cookies.remove("userType")
        Cookies.remove("userId")
        Cookies.remove("factoryId");
        Cookies.remove("createBy");
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
